module.exports = __webpack_public_path__ + "static/media/21ECLAC36.556c62e2.jpg";